<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom-narrow"></div>

        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <subscriptions-overview :tableData="subscriptions" />
            </div>
        </div>
    </div>
</template>

<script>
import { subscriptionsMixin, SubscriptionsOverview } from 'relapp-administrative-management';

export default {
    components: {
        SubscriptionsOverview
    },
    mixins: [subscriptionsMixin]
};
</script>
